/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Top_Users_Top_Model_LabelInputs */



/**
* | output |
* | --- |
* | "Top Model:" |
*
* @param {Dashboard_Top_Users_Top_Model_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_top_users_top_model_label = /** @type {((inputs?: Dashboard_Top_Users_Top_Model_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Top_Users_Top_Model_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Top-Modell:")
	return /** @type {LocalizedString} */ ("Top Model:")
});